import { AutocompleteInput, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { Briefcase } from "lucide-react";
import {
  Create,
  NumberInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
} from "../common";

const DesignationToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Save Designation" />
  </div>
);

export const DesignationCreate = () => (
  <Create title="Create Designation">
    <Card className="form-container">
      <div className="form-header-premium">
        <Briefcase className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Add New Designation</h2>
      </div>
      <SimpleForm toolbar={<DesignationToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="title" label="Designation Title" />
          <NumberInput source="level" label="Hierarchical Level" />
          <ReferenceInput source="department_id" reference="hr_departments">
            <AutocompleteInput label="Department" optionText="name" />
          </ReferenceInput>
        </div>
      </SimpleForm>
    </Card>
  </Create>
);

